import { actionSet } from './utils'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from './spinner'

import { callWithPagination, getPages } from 'component/pagination/utils'

import {
  LIST_DATASHEET_MANAGEMENT_SUCCESS,
  LIST_DATASHEET_MANAGEMENT_ERROR,
  SAVE_DATASHEET_MANAGEMENT_SUCCESS,
  SAVE_DATASHEET_MANAGEMENT_ERROR,
  DELETE_DATASHEET_MANAGEMENT_SUCCESS,
  DELETE_DATASHEET_MANAGEMENT_ERROR,
  CLEAR_DATASHEET_MANAGEMENT_SUCCESS_MESSAGE,
  CLEAR_DATASHEET_MANAGEMENT_ERROR_TYPE,
  LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS,
  LIST_DATASHEET_MANAGEMENT_REQUEST
} from 'constants/actionTypes'

const HAS_PAGINATION = true

export const listDatasheetManagement = (token, page, size) => (dispatch) =>
  new Api(token, dispatch)
    .get(API_URL.LIST_DATASHEET_MANAGEMENT)
    .then(dispatch(showSpinner()))
    .then(
      async (response) => {
        dispatch(actionSet(LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS, response.data))
        dispatch(
          callWithPagination(
            response.data,
            dispatch,
            LIST_DATASHEET_MANAGEMENT_SUCCESS,
            0,
            page,
            size
          )
        )
      },
      (error) => {
        dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_ERROR, error))
      }
    )
    .finally(() => dispatch(hideSpinner()))


export const getSections = (token, list, callbackSections) => async dispatch => {
  let sections = {}

  dispatch(showSpinner())

  await Promise.all(
    list.map(async (item) => {
      let level

      if (item.subTypeId) {
        level = 5
      } else if (item.typeId) {
        level = 4
      } else if (item.subSectionId) {
        level = 3
      } else {
        level = 2
      }

      for (let i = level; i > 1; i -= 1) {
        const params = {
          limit: 50,
          offset: 0,
          sectionId: item.sectionId,
          subSectionId: i > 2 ? item.subSectionId : 0,
          typeId: i > 3 ? item.typeId : 0,
          subTypeId: i > 4 ? item.subTypeId : 0,
          level: i,
        }

        const { data } = await new Api(token)
          .post(API_URL.SECTIONS_HIERARCHY, params)
          .catch(() => ({
            data: [
              {
                sectionId: item.sectionId,
                subSectionId: 0,
                subTypeId: 0,
                typeId: 0,
                level: i,
              },
            ],
          }))

        const incoming = Array.isArray(data) ? data : [data]
        const existing = sections[i] || []
        const merged = [...existing, ...incoming].filter(
          (entry, index, arr) =>
            entry &&
            arr.findIndex(
              (other) =>
                other.sectionId === entry.sectionId &&
                other.subSectionId === entry.subSectionId &&
                other.typeId === entry.typeId &&
                other.subTypeId === entry.subTypeId
            ) === index
        )

        sections = { ...sections, [i]: merged }
      }
    })
  )

  dispatch(hideSpinner())

  callbackSections(sections)
}

export const filterListDatasheetManagement =
  (token, page, size, params) => (dispatch) =>
    new Api(token, dispatch)
      .post(API_URL.FILTER_LIST_DATASHEET_MANAGEMENT, params)
      .then(dispatch(showSpinner()))
      .then(
        (data) => {
          dispatch(actionSet(LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS, data))
          dispatch(
            callWithPagination(
              data,
              dispatch,
              LIST_DATASHEET_MANAGEMENT_SUCCESS,
              0,
              page,
              size
            )
          )
        },
        (error) => {
          dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_ERROR, error))
        }
      )
      .finally(() => dispatch(hideSpinner()))

export const saveDatasheetManagement = (token, params) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.SAVE_DATASHEET_MANAGEMENT, params)
    .then(dispatch(showSpinner()))
    .then(
      (response) => {
        dispatch(actionSet(SAVE_DATASHEET_MANAGEMENT_SUCCESS, response.data))
      },
      (error) => {
        dispatch(actionSet(SAVE_DATASHEET_MANAGEMENT_ERROR, error))
      }
    )
    .finally(() => dispatch(hideSpinner()))

export const deleteDatasheetManagement = (token, params) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.DELETE_DATASHEET_MANAGEMENT, params)
    .then(dispatch(showSpinner()))
    .then(
      () => {
        dispatch(actionSet(DELETE_DATASHEET_MANAGEMENT_SUCCESS))
      },
      (error) => {
        dispatch(actionSet(DELETE_DATASHEET_MANAGEMENT_ERROR, error))
      }
    )
    .finally(() => dispatch(hideSpinner()))

export const clearSuccessMessage = () => (dispatch) =>
  dispatch(actionSet(CLEAR_DATASHEET_MANAGEMENT_SUCCESS_MESSAGE))

export const clearError = () => (dispatch) =>
  dispatch(actionSet(CLEAR_DATASHEET_MANAGEMENT_ERROR_TYPE))


// FLUX LIST
export const listDatasheetManagementFlux =
(token, page, size, signalController) => (dispatch) => {
  dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_REQUEST))

  const pagination = {
    page,                        
    size,                        
    offset: (page - 1) * size,  
    hasPagination: HAS_PAGINATION,
  }

  const onMessage = (response) => {
    dispatch(getPages(response.pages));
    dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_SUCCESS, response));
    
  };

  const onClose = () => {
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_ERROR, error))
  }

  const abort = () => {
    signalController.abort()
    dispatch(hideSpinner())
    dispatch(hideSpinner())
    onClose()
  }

  dispatch(showSpinner("", true, abort))

  return new Api(token, dispatch)
    .eventSourceStream(API_URL.LIST_DATASHEET_MANAGEMENT, pagination, null, signalController, onMessage, onClose, onError)
    .catch((error) => onError(error))
}

// FLUX FILTER
export const filterListDatasheetManagementFlux =
(token, page, size, filters, signalController) => (dispatch) => {
  dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_REQUEST))

  const pagination = {
    page,                        
    size,                        
    offset: (page - 1) * size,  
    hasPagination: HAS_PAGINATION,
  }

  // Remove nulls e arrays vazios
  const cleanParams = Object.fromEntries(
    Object.entries({
      ...filters,
      ...pagination,
    }).filter(([, value]) => {
      if (value === null) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      return true;
    })
  );

  const onMessage = (response) => {
    dispatch(getPages(response.pages));
    dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_SUCCESS, response));
    
  };

  const onClose = () => {
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(actionSet(LIST_DATASHEET_MANAGEMENT_ERROR, error))
  }

  const abort = () => {
    signalController.abort()
    dispatch(hideSpinner())
    dispatch(hideSpinner())
    onClose()
  }

  dispatch(showSpinner("", true, abort))

  return new Api(token, dispatch)
    .eventSourceStream(API_URL.FILTER_LIST_DATASHEET_MANAGEMENT_FLUX, cleanParams, null, signalController, onMessage, onClose, onError)
    .catch((error) => onError(error))
}
